
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input, OnInit } from '@angular/core';
import { InboxDto } from '@app/core/model';
import { NotificationService } from '@app/core/service';
import { InboundFaxesTableModel } from '@app/shared/models';
import { MfeCoreModule } from '@mynexus/mfe-core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'ifa-attach-to-authorization-modal',
    templateUrl: './attach-to-authorization-modal.component.html',
    styleUrls: ['./attach-to-authorization-modal.component.scss'],
    imports: [MfeCoreModule, ProgressSpinnerModule],
    providers: [NotificationService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AttachToAuthorizationModalComponent implements OnInit {
  @Input() inboundFax!: InboundFaxesTableModel;
  @Input() inbox!: InboxDto;

  tenantLobProductId: string;
  product: string;
  isLoading = true;

  ref = inject(DynamicDialogRef);
  notificationService = inject(NotificationService);
  private config = inject(DynamicDialogConfig);

  public ngOnInit(): void {
    this.config.closable = true;
    if (this.config.data) {
      this.inboundFax = this.config.data.inboundFax;
      this.inbox = this.config.data.inbox;
      this.tenantLobProductId = this.config.data.inbox.tenantLobProduct?.tenantLobProductId;
      this.product = this.config.data.inbox.tenantLobProduct?.productShortName;
    }
  }

  public onComplete(event: CustomEvent): void {
    const authNumber: string = event.detail;
    this.notificationService.showSuccess(
      'Successfully Attached Fax to Authorization',
      `Fax has been attached to ${authNumber}`
    );

    this.ref.close(true);
  }
}
